import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from './network/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** Alphabetical, umlaut-aware ("Sürth", "Zündorf") and number-aware ("… 2" before "… 10"). */
export function sortParkAreasByName<T extends { name?: string }>(areas: T[]): T[] {
  return [...(areas ?? [])].sort((a, b) =>
    (a?.name ?? '').localeCompare(b?.name ?? '', 'de', { numeric: true, sensitivity: 'base' }));
}
@Injectable({
  providedIn: 'root'
})
export class ParkAreasService {

  baseUrl: String = environment.parkAreaApiUrl;

  constructor(
    private _network: ApiService
  ) { }

  get() {
    const result = this._network.get(this.baseUrl + "/parkarea");
    return result;
  }
  getByCompany(companyId: any, limit: any, skip: any): Observable<any> {
    // Every park-area dropdown uses this list, so sort it once here.
    return this._network.get(this.baseUrl + "/parkareas/" + companyId + "/" + "?limit=" + limit + '&skip=' + skip)
      .pipe(map((res: any) => Array.isArray(res?.data) ? { ...res, data: sortParkAreasByName(res.data) } : res));
  }
  getById(id: any) {
    const result = this._network.get(this.baseUrl + "/parkarea/" + id);
    return result;
  }
  post(parkArea: any) {
    const result = this._network.post(this.baseUrl + "/parkarea", parkArea);
    return result;
  }
  put(parkArea: any) {
    const result = this._network.put(this.baseUrl + "/parkarea/" + parkArea._id, parkArea);
    return result;
  }
  putResponsibles(responsibles: any, userId: any) {
    const result = this._network.put(this.baseUrl + "/parkarea/" + userId + "/responsibles", { "parkAreaIds": responsibles });
    return result;
  }
  delete(id: any) {
    const result = this._network.delete(this.baseUrl + "/parkarea/" + id);
    return result;
  }
  getMailLogsByCompany(companyId: any, limit: any, skip: any) {
    const result = this._network.get(this.baseUrl + "/maillogs/" + companyId + "?limit=" + limit + '&skip=' + skip);
    return result;
  }
  getMailLogsByParkAreaId(companyId: any, parkAreaId: any, limit: any, skip: any, from: any, to: any) {
    let result;
    if (parkAreaId == 0) {
      result = this._network.get(this.baseUrl + "/maillogs/" + companyId + "?from=" + from + "&to=" + to + "&limit=" + limit + '&skip=' + skip);

    } else {
      result = this._network.get(this.baseUrl + "/maillogs/" + companyId + "/" + parkAreaId + "?from=" + from + "&to=" + to + "&limit=" + limit + '&skip=' + skip);


    }
    return result;
  }
   getViolationByParkAreaId(companyId: any, parkAreaId: any,slotNumber:any ,limit: any, skip: any, from: any, to: any) {
    let result;
    if (parkAreaId == 0) {
      result = this._network.get(this.baseUrl + "/violations/" + companyId + "?from=" + from+' 00:00:00' + "&to=" + to+' 23:59:59' + "&limit=" + limit + '&skip=' + skip);

    }else if (slotNumber == 'all') {
      result = this._network.get(this.baseUrl + "/violations/" + companyId + "/" + parkAreaId + "?from=" + from+' 00:00:00' + "&to=" + to+' 23:59:59' + "&limit=" + limit + '&skip=' + skip);

    }
     else {
      result = this._network.get(this.baseUrl + "/violations/" + companyId + "/" + parkAreaId +"?slotNumber="+slotNumber+ "&from=" + from+' 00:00:00' + "&to=" + to+' 23:59:59' + "&limit=" + limit + '&skip=' + skip);
    }
    return result;
  }

    getViolationByCompany(companyId: any, limit: any, skip: any) {
    const result = this._network.get(this.baseUrl + "/violations/" + companyId + "?limit=" + limit + '&skip=' + skip);
    return result;
  }

}
